<div class="pagination-container">
  <!-- Page Information -->
  <div class="page-info">
    @if (paginationInfo) {
      Showing {{ paginationInfo.startItem }} to {{ paginationInfo.endItem }} of {{ paginationInfo.totalItems }} entries
    }
  </div>

  <!-- Pagination Controls -->
  @if (paginationInfo) {
    <div class="pagination-controls">
      <!-- Previous Button -->
      <button 
        pButton 
        type="button" 
        icon="pi pi-chevron-left"
        class="p-button-text p-button-sm"
        [disabled]="paginationInfo.currentPage === 1"
        (click)="onPreviousPage()"
      ></button>

      <!-- Page Numbers -->
      <div class="page-numbers">
        @for (page of visiblePages; track page) {
          @if (page === -1) {
            <span class="ellipsis">...</span>
          } @else {
            <button 
              pButton 
              type="button" 
              class="p-button-text p-button-sm page-number"
              [class.active]="page === paginationInfo.currentPage"
              (click)="onPageChange(page)"
            >
              {{ page }}
            </button>
          }
        }
      </div>

      <!-- Next Button -->
      <button 
        pButton 
        type="button" 
        icon="pi pi-chevron-right"
        class="p-button-text p-button-sm"
        [disabled]="paginationInfo.currentPage === paginationInfo.totalPages"
        (click)="onNextPage()"
      ></button>
    </div>
  }
</div>
